import { render, staticRenderFns } from "./FloorShow.vue?vue&type=template&id=06514e1b&scoped=true"
import script from "./FloorShow.vue?vue&type=script&lang=js"
export * from "./FloorShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06514e1b",
  null
  
)

export default component.exports